









import CommonBase from "../../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import {RouteRecord} from "vue-router";

@Component
export default class ReportCard extends CommonBase {
    @Prop()
    reportTo!: RouteRecord;
    @Prop()
    title!: string;
}
